import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ThemeService } from '@app/infra/theme/theme.service';
import { AuthRepository } from '@data/auth/auth.repository';
import { AuthService } from '@infra/auth/auth.service';
import { map } from 'rxjs';

@Injectable()
export class LogoutController {
  constructor(
    private authService: AuthService,
    private themeService: ThemeService,
    private authRepository: AuthRepository,
    public router: Router
  ) {}

  logout() {
    return this.authRepository.getLogout().pipe(
      map((item) => {
        this.authService.credentials = null;
        this.router.navigate([this.themeService.identificador]);
        return item;
      })
    );
  }
}
